import { render, staticRenderFns } from "./delete-document-template.vue?vue&type=template&id=408c46b4&scoped=true&"
import script from "./delete-document-template.vue?vue&type=script&lang=js&"
export * from "./delete-document-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c46b4",
  null
  
)

export default component.exports